import { useApi } from '../../api/api-context';
import { useQueryMutation } from '../../api/use-query-mutation';
import { useBudgetId } from '../../budget/budget-store';
import { logAndThrowError } from '../../utils/errors';
import { applyTransactionUpdate } from '../transaction-utils';
export const useUpdateTransactionApi = (options) => {
    const api = useApi();
    const budgetId = useBudgetId();
    const queryKey = ['transactions', budgetId];
    // api call
    const updateTransactionApi = async (data) => {
        await api.put('/account/transaction', data);
    };
    // optimistic update
    const onMutate = (oldData, request) => {
        if (!oldData) {
            logAndThrowError('No transactions data found');
        }
        return applyTransactionUpdate(oldData, request);
    };
    return useQueryMutation(updateTransactionApi, queryKey, onMutate, options);
};
